import * as React from 'react';
import { useGlobalState } from 'piral-core';
import { PiralModalsDialog, PiralModalsHost } from './components';
function closeAll(modals) {
    modals.forEach((m) => m.close());
}
function findModal(modals, name) {
    if (name) {
        const [modal] = Object.keys(modals)
            .filter((m) => modals[m].name === name)
            .map((m) => modals[m]);
        return modal;
    }
    return undefined;
}
export const Modals = () => {
    const modals = useGlobalState((s) => s.registry.modals);
    const dialogs = useGlobalState((s) => s.modals);
    const close = () => closeAll(dialogs);
    const children = dialogs
        .map((n) => {
        const reg = modals[n.name] || findModal(modals, n.alternative);
        const Component = reg && reg.component;
        const defaults = reg && reg.defaults;
        const options = {
            ...defaults,
            ...n.options,
        };
        return (Component && (React.createElement(PiralModalsDialog, { ...n, options: options, defaults: reg.defaults, layout: reg.layout, key: n.name },
            React.createElement(Component, { onClose: n.close, options: options }))));
    })
        .filter(Boolean);
    const open = children.length > 0;
    return (React.createElement(PiralModalsHost, { open: open, close: close }, children));
};
Modals.displayName = 'Modals';
//# sourceMappingURL=Modals.js.map